export const trackingEvents = {
  REMOVE_SELECTED: {
    CLICKED: 'employer_blocklist.remove_selected.clicked',
  },
  ADD_WORKER_TO_BLACKLIST: {
    CLICKED: 'employer_blocklist.add_worker_to_blocklist.clicked',
  },
}
